import * as React from "react";

import { Form } from "tabler-react";

import { FormCard } from "../Form";

interface Props {
  open: boolean;
  job: any;
  handleInputChange: any;
  handleSubmit: any;
  handleChange: any;
  errors: any;
  values: any;
  isSubmitting: boolean;
}

const JobApplyForm: React.SFC<Props> = ({
  job,
  handleSubmit,
  handleChange,
  handleInputChange,
  errors = {},
  values = {},
  isSubmitting,
}) => {
  const organization = job.organization || job.workspace;
  return (
    <FormCard
      buttonText="Submit"
      title={`Apply to ${organization.name}(${job.title})`}
      onSubmit={handleSubmit}
      action={null}
      method={null}
      loading={isSubmitting}
    >
      <Form.Group label="Name">
        <Form.Input
          name="name"
          type="text"
          error={errors && errors.name}
          value={values.name}
          onChange={handleInputChange}
          placeholder="Enter name"
        />
      </Form.Group>
      <Form.Group label="Email">
        <Form.Input
          name="email"
          type="email"
          value={values.email}
          error={errors && errors.email}
          onChange={handleInputChange}
          placeholder="Enter email"
        />
      </Form.Group>
      <Form.Group label="Mobile">
        <Form.Input
          name="mobile"
          type="number"
          value={values.mobile}
          error={errors && errors.mobile}
          onChange={handleInputChange}
          placeholder="Enter mobile"
        />
      </Form.Group>
      <Form.Group label="Resume">
        <Form.FileInput onChange={handleChange} label="Choose resume" />
        <span className="error">{errors.file}</span>
      </Form.Group>
    </FormCard>
  );
};

export default JobApplyForm;
